<template>
  <div class="make-payment-container">
    <div id="top-target" class="bill-pay-success-fail">
      <div class="bill-pay-fail__intro-image gds-space-stack-xl">
        <img class="my-account__payment-plan-icon" src="/wp-content/themes/gmptwentynineteen/assets/images/pay-fatal-error.svg" alt="unsuccessful payment" />
      </div>

      <h2 class="gds-display-2 gds-align--text-center gds-space-stack-ml">Oh no!</h2>

      <div v-if="code === 1002" class="error-1002 form-message-box gds-space-stack-l gds-align--text-center">The ZIP Code was incorrect.</div>
      <div v-if="code === 1019 || code === 1026" class="error-1019 error-1026 form-message-box gds-space-stack-l gds-align--text-center">The credit card type is not supported.</div>
      <!-- The following errors are handled upstream and should never reach here -->
      <div v-if="code === 1001" class="error-1001 form-message-box gds-space-stack-l gds-align--text-center">The card was declined.</div>
      <div v-if="code === 3307" class="error-3307 form-message-box gds-space-stack-l gds-align--text-center">The payment was a duplicate.</div>
      <div v-if="code === 3803" class="error-3803 form-message-box gds-space-stack-l gds-align--text-center">More than 2 card payments have been made this month.</div>
      <div v-if="code === 28002" class="error-28002 form-message-box gds-space-stack-l gds-align--text-center">A payment method with that nickname already exists for this account.</div>

      <div v-if="!isRecurring" class="bill-pay-fail__description gds-body-large gds-align--text-center gds-space-stack-xl">
        We were unable to process your payment at this time. Please try again or contact customer support for assistance at
        <span class="gds-nobreak">{{GMPPhoneNumber}}.</span>
      </div>
      <div v-else class="bill-pay-fail__description gds-body-large gds-align--text-center gds-space-stack-xl">
        We were unable to process your payment at this time and recurring payments have not been set up. Please try again or contact customer support for assistance at
        <span class="gds-nobreak">{{GMPPhoneNumber}}.</span>
      </div>

      <div class="bill-pay-success__button-wrap gds-align--text-center gds-space-stack-l">
        <!-- <router-link to="/pay/1" class="bill-pay-success__button gds-button gds-secondary gds-space-inline-s">Back</router-link> -->
        <button @click="ReturnToSender('/make-payment')" type="button" class="bill-pay-success__button gds-button">Done</button>
      </div>
    </div>
  </div>
</template>

<script>
import { GMPPhoneNumber } from "../../environment";
import { ReturnToSender } from "../../utilities";

export default {
  name: "BillPayFatalError",
  data() {
    return {
      ReturnToSender,
      GMPPhoneNumber,
    };
  },
  computed: {
    code() {
      return Number(this.$route.params.code);
    },
    isRecurring() {
      return this.$route.params.isRecurringPayments;
    }
  },
  async mounted() {
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>